<div class="tracking-container" [ngClass]="{'employee': isEmployee, 'machine': !isEmployee}">
  <div class="tracking-form">
    <ng-container *ngIf="(servicesTypes$ | async) as serviceTypes">
      <ng-container *ngIf="serviceTypes.length >0">
        <mat-form-field>
          <mat-label>Leistungsart</mat-label>
          <mat-select [(value)]="selectedServiceType" (selectionChange)="onTrackingChanged()">
            <mat-option *ngFor="let serviceType of serviceTypes" [value]="serviceType">
              {{ serviceType.TEXT }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </ng-container>
    </ng-container>

    <ng-container *ngIf="(ratingTypes$ | async) as ratingTypes">
      <ng-container *ngIf="ratingTypes.length > 0">
        <mat-form-field>
          <mat-label>Wertungsart</mat-label>
          <mat-select [(value)]="selectedRatingType" (selectionChange)="onTrackingChanged()">
            <mat-option *ngFor="let ratingType of ratingTypes" [value]="ratingType">
              {{ ratingType.TEXT }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </ng-container>
    </ng-container>
  </div>

  <div class="tag-container">
    <div *ngIf="isEmployee" class="employee-tag">Mitarbeiter</div>
    <div *ngIf="!isEmployee" class="machine-tag">Maschine</div>
  </div>
</div>

